var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-slider", {
    attrs: {
      "data-nosnippet": "",
      items: _vm.recommendationsItems,
      "extra-large-screen-visible-items-count":
        _vm.extraLargeScreenVisibleItemsCount,
      "large-screen-visible-items-count": _vm.largeScreenVisibleItemsCount,
      "medium-screen-visible-items-count": _vm.mediumScreenVisibleItemsCount,
      "small-screen-visible-items-count": _vm.smallScreenVisibleItemsCount,
      "slide-gap-classes": "_px-2 _px-3--m",
      "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
      "is-processing": _vm.isProcessing,
    },
    on: {
      "get-items": _vm.getRecommendationItems,
      "scroll-left": _vm.onScrollLeft,
      "scroll-right": _vm.onScrollRight,
    },
    scopedSlots: _vm._u([
      {
        key: "prefix",
        fn: function () {
          return [
            _c("h2", { staticClass: "gfu-hd gfu-hd--h2 _mb-1" }, [
              _vm._v(_vm._s(_vm.recommendationTitle)),
            ]),
            _vm._v(" "),
            _c(
              "localize",
              {
                attrs: {
                  resource:
                    _vm.Resources.ProjectHome.ProjectRecommendationsText,
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "gfu-link gfu-link--accent",
                    attrs: { "format-key": "0", href: _vm.searchUrl },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.Resources.ProjectHome
                          .ProjectRecommendationsSearchLink
                      )
                    ),
                  ]
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }